import React, { Component } from 'react';
import { Button, Input, Icon, Dropdown, Menu, message } from 'utils/ui';
import { observer } from 'mobx-react';
import ModalShell from '../common/ModalShell';
import ModalBody from '../common/ModalBody';
import FormField from '../common/FormField';
import { addPersonalNote } from '../api_calls/user';
const { TextArea } = Input;

@observer(['UserStore', 'AuthStore', 'FamilyStore'])
class AddPersonalNote extends Component {
    constructor(props) {
        super(props);
        this.state = {
            note: "",
            modalOpen: false,
            submittingNewNote: false,
            stepOneComplete: false
        };
        this.onSubmitClick = this.onSubmitClick.bind(this);
        this.stepOne = this.stepOne.bind(this);
        this.stepTwo = this.stepTwo.bind(this);
        this.memberClicked = this.memberClicked.bind(this);
    }
    memberClicked(member) {
        this.setState({ stepOneComplete: true, personSelected: member, memberSelected: true });
    }
    stepOne() {
        const { FamilyStore, UserStore } = this.props;
        let dropdownContents = [];
        FamilyStore.family.forEach(member => {
            dropdownContents.push(<Menu.Item onClick={this.memberClicked.bind(this, member)} key={member._id}>{member.name}</Menu.Item>);
        });
        UserStore.user.nonUserPeople.forEach((person, idx) => {
            dropdownContents.push(<Menu.Item key={idx}>{person.name}</Menu.Item>);
        });

        const menu = (<Menu>{dropdownContents}</Menu>);
        return <div className="ui-modal-stack">
            <span style={{ fontSize: "16pt", color: "#1e293b" }} className="AppFont">Who is this about?</span>
            <Dropdown overlay={menu}>
                <span style={{ cursor: "pointer", color: "rgb(24, 144, 255)" }} className="ant-dropdown-link" onClick={e => e.preventDefault()}>
                    Someone in my group <Icon type="down" />
                </span>
            </Dropdown>
            <Button style={{ backgroundColor: "rgba(0,0,0,0", color: "#1890ff", border: "none" }} onClick={() => { this.setState({ stepOneComplete: true, noneSelected: true }) }}>Nobody</Button>
            <Button style={{ backgroundColor: "rgba(0,0,0,0", color: "#1890ff", border: "none" }} onClick={() => { this.setState({ stepOneComplete: true, otherSelected: true }) }}>Someone Else</Button>
            <div className="ui-modal-actions">
                <Button className="AppFont btn-cancel ui-btn-danger" onClick={() => { this.setState({ modalOpen: false, stepOneComplete: false }) }} size="large"><Icon type="close" /> Cancel</Button>
            </div>
        </div>;
    }
    stepTwo() {
        return <div className="ui-modal-stack">
            <span className="AppFont" style={{ color: '#1e293b' }}>{this.state.personSelected ? "New note about " + this.state.personSelected.name.slice(0, 1).toUpperCase().concat(this.state.personSelected.name.slice(1)) : `New${this.state.noneSelected ? " General" : ""} Note`}</span>
            {this.state.otherSelected ?
                <FormField label="About who?">
                    <Input onChange={e => this.setState({ newPerson: e.target.value })}></Input>
                </FormField>
                : ""}
            <FormField label="Note Content">
                <TextArea onChange={(e) => { this.setState({ note: e.target.value }) }} autoSize={{ minRows: 3, maxRows: 6 }} />
            </FormField>
            <Button style={{ backgroundColor: "rgba(0,0,0,0", color: "#1890ff", border: "none" }} onClick={() => { this.setState({ stepOneComplete: false, otherSelected: false, noneSelected: false, personSelected: "" }) }}><Icon type="left" />Go Back</Button>
            <div className="ui-modal-actions">
                <Button className="AppFont btn-submit ui-btn-success" onClick={this.onSubmitClick.bind(this)} size="large"><Icon type="check-circle" /> Submit</Button>
                <Button className="AppFont btn-cancel ui-btn-danger" onClick={() => { this.setState({ modalOpen: false, stepOneComplete: false }) }} size="large"><Icon type="close" /> Cancel</Button>
            </div>
        </div>;
    }
    onSubmitClick() {
        const { UserStore, AuthStore } = this.props;
        if (this.state.submittingNewNote) {
            return;
        }
        let self = this;
        const normalizedBody = (this.state.note || "").trim();
        if (!normalizedBody) {
            message.warn("Please enter a note before submitting.");
            return;
        }

        self.setState({ submittingNewNote: true });
        let user = UserStore.childViewActive ? UserStore.activeChild.id : UserStore.user._id;
        const aboutPerson = this.state.personSelected ? this.state.personSelected._id : this.state.newPerson || "";
        const aboutGroupMember = !!this.state.memberSelected;
        const existing = (UserStore.user.privateNotes || []).some((note) =>
            (note.body || "").trim() === normalizedBody &&
            !!note.aboutGroupMember === aboutGroupMember &&
            String(note.aboutPerson || "") === String(aboutPerson || "")
        );
        if (existing) {
            message.info("That note already exists.");
            self.setState({ submittingNewNote: false });
            return;
        }

        let noteObject = { body: normalizedBody, aboutGroupMember, aboutPerson };
        addPersonalNote(user, noteObject, AuthStore.userAuth.auth.accessToken).then(() => {
            message.success("Note added");
            self.setState({ submittingNewNote: false, modalOpen: false, stepOneComplete: false, otherSelected: false, personSelected: "", noneSelected: false });
            UserStore.refreshUser(AuthStore.userAuth.auth.accessToken);
        });
    }
    render() {
        const { UserStore } = this.props;
        const menuButtonStyle = {
            border: 'none',
            textAlign: 'center',
            padding: '15px',
            cursor: 'pointer',
            backgroundColor: UserStore.theme().icons || "white",
            color: UserStore.theme().font2 || "black",
            borderRadius: '40px',
            marginLeft: "5px",
            marginRight: "5px",
            marginTop: "5px"
        };
        return (
            <div>
                <ModalShell
                    className="register-modal"
                    overlayClassName="register-modal-overlay"
                    isOpen={this.state.modalOpen}
                    onRequestClose={() => { (this.state.submittingNewNote ? console.log("tried to close") : this.setState({ modalOpen: false })) }}
                    maxWidth={640}
                >
                    <ModalBody title="Add Personal Note" subtitle="Keep private notes tied to a person or topic" className="ui-modal-surface-compact">
                        <div style={{ minHeight: 140 }}>
                            {!this.state.stepOneComplete ? this.stepOne() : this.stepTwo()}
                        </div>
                    </ModalBody>
                </ModalShell>

                <div style={{
                    position: "fixed",
                    zIndex: 999,
                    width: "100%",
                    padding: "10px 20px",
                    backdropFilter: "blur(10px)",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                    display: "flex",
                    alignItems: "center"
                }}><Button style={{
                    ...menuButtonStyle, display: 'inline-flex',
                    alignItems: 'center',
                    gap: '8px',
                    padding: '8px 12px',
                    borderRadius: '8px',
                    color: '#fff',
                    cursor: 'pointer',
                    userSelect: 'none',
                    fontWeight: '600',
                    transition: 'all 0.2s ease',
                    boxShadow: '0 2px 4px rgba(74,144,226,0.2)'
                }}
                    onClick={() => this.setState({ modalOpen: true })}
                    size="large"
                >
                        <Icon type="file-add" />Add Note
                    </Button>
                </div>
            </div>
        );
    }
}

export default AddPersonalNote;